import { render } from "./cargo-v2-edit-layout.vue?vue&type=template&id=7b67b36a&ts=true"
import script from "./cargo-v2-edit-layout.vue?vue&type=script&lang=ts"
export * from "./cargo-v2-edit-layout.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__